<button
  class="btn {{ gender }} {{ cssClasses }}"
  [ngClass]="{ cta: isCTA, loading: loading }"
  type="{{ type }}"
  (click)="onClickButton($event)"
  [disabled]="isDisabled"
>
  <ng-content></ng-content>
</button>
